// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a{text-decoration:underline;color:#000}", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/lib!./node_modules/sass-loader/dist/cjs.js!./src/App.scss
// module id = 91
// module chunks = 0